/**
 * A lookup that takes a Period and returns the number of those in a year, this
 * is used when calculating the number of minutes for a task for a year
 * @type {{Month: number, Year: number, Hour: number, Day: number, Week: number}}
 */
export const PERIOD_MULTIPLIER = {
    Hour: 365 * 24,
    Day: 365,
    Week: 52,
    Month: 12,
    Year: 1,
    Unknown: 0,
}

export const PERIOD_SORT = {
    Hour: 1,
    Day: 24,
    Week: 24 * 7,
    Month: 24 * (365 / 12),
    Year: 24 * 365,
}

export const PERIOD_DENORMALIZE = {
    Hour: 1,
    Day: 24,
    Week: 24 * 7,
    Month: 24 * 7 * 4,
    Year: 24 * 7 * 4 * 12,
}

export const PERIOD_DENORMALIZE_INITIAL = {
    H: 1,
    D: 24,
    W: 24 * 7,
    M: 24 * 7 * 4,
    Y: 24 * 7 * 4 * 12,
}

export const INITIAL_TO_PERIOD = {
    H: "Hour",
    D: "Day",
    W: "Week",
    M: "Month",
    Y: "Year",
}

/**
 * A lookup that returns a colour for a classification
 * @type {{Red: string, Pink: string, Amber: string, Green: string}}
 */
export const COLOR_FROM_CLASSIFICATION = {
    Red: "#e50f16",
    Green: "#228B22",
    Amber: "#fc6a03",
    Pink: "#FF69B4",
}

export const COLOR_UNLICENSED = {
    dark: "#7D4E2D",
}

export const CLASSIFICATIONS = ["Red", "Pink", "Amber", "Green"]

export const ICON_FROM_CLASSIFICATION = {
    Red: "bi:diamond-fill",
    Pink: "fluent:triangle-32-filled",
    Amber: "fluent:circle-24-filled",
    Green: "fluent:triangle-down-12-filled",
}

export const SORT_FROM_CLASSIFICATION = {
    Red: 0,
    Pink: 1,
    Amber: 2,
    Green: 3,
}

/**
 * The classifications that the system supports
 * @type {string[]}
 */
export const VALID_CLASSIFICATIONS = ["Red", "Pink", "Amber", "Green"]
export const VALID_CLASSIFICATIONS_REVERSE = [...VALID_CLASSIFICATIONS].reverse()
export const OVERARCHING_INTRODUCTION = "34164"

/**
 * The legal entity shown in copyright and trade mark notices (PDFs, Excel
 * exports, emails, footers). Lives here because client and server both import
 * this file; "lib/" is client-only.
 * @type {string}
 */
export const COMPANY_LEGAL_NAME = "SFG20 Limited"
